import * as React from "react";
import { InjectedFormProps, reduxForm } from "redux-form";
import Button from "src/components/Button";
import TextAreaField from "src/components/TextAreaField";
import TextInput from "src/components/TextInput";
import Typography from "src/components/Typography";
import styles from "./ConnectForm.module.css";

interface Props extends InjectedFormProps<FormData> {}

type FormData = {
  email: string;
  text: string;
  name: string;
};

class RegistrationFrom extends React.Component<Props> {
  public render() {
    const { props } = this;
    const isDisabled = !!(
      props.submitting ||
      !props.anyTouched ||
      props.error ||
      props.invalid
    );

    return (
      <form onSubmit={props.handleSubmit}>
        <div className={styles.formWrapper}>
          <div className={styles.mobileTextWrapper}>
            <Typography type="h3" black>
              <h3>Напишите нам</h3>
            </Typography>
            <Typography type="text" black>
              Опиши проблему или расскажи, что тебе не хватает на платформе
            </Typography>
          </div>
          <div className={styles.inputWrapper}>
            <TextInput name="email" label="email" black />
            <TextInput name="name" label="Имя" black />
            <TextAreaField
              name="text"
              placeholder="Введите ваше обращение здесь."
              black
              rows={10}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <Button disabled={isDisabled} type="submit">
              ОТПРАВИТЬ
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

const validate = (values: FormData) => {
  const errors: { email?: string; name?: string } = {};
  const requiredFields = ["email", "name", "text"];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Обязательное поле";
      return;
    }
    // tslint:disable-next-line: no-unsafe-any
    if (values[field].length < 2) {
      errors[field] = "Недостаточная длинна значения";
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  ) {
    errors.email = "Invalid email address";
  }
  return errors;
};

export default reduxForm<FormData>({
  form: "ConnectFrom", // a unique identifier for this form
  validate,
})(RegistrationFrom);
